import {
  CompanyWithCollaborativesDto,
  CompanyWithCollaborativesPageDto,
} from "../../../types/company/company-dto";
import { convertCompanyWithCollaborativesDtoToCompanyWithCollaboratives } from "../../../utils/converter/user/company-with-collaboratives-convertor";
import { CompanyState } from "../../type/company-state";

interface Action {
  type: string;
  payload: {
    companyWithCollaborativesPageAllDto: CompanyWithCollaborativesPageDto;
  };
}

export const setCompanyWithCollaborativesPageAllDispatch = (
  state: CompanyState,
  action: Action
) => {
  const { companyWithCollaborativesPageAllDto } = action.payload;

  state.companyWithCollaborativesPageAll = {
    contents: companyWithCollaborativesPageAllDto.contents.map(
      (companyWithCollaborativesDto: CompanyWithCollaborativesDto) => {
        return convertCompanyWithCollaborativesDtoToCompanyWithCollaboratives(
          companyWithCollaborativesDto
        );
      }
    ),
    first: companyWithCollaborativesPageAllDto.first,
    last: companyWithCollaborativesPageAllDto.last,
    page: companyWithCollaborativesPageAllDto.page,
    totalPages: companyWithCollaborativesPageAllDto.totalPages,
    totalElements: companyWithCollaborativesPageAllDto.totalElements,
  };
};
